<template>
  <div id="tab-competences" class="tab-competences">
    <div v-if="competences.length > 0">
      <div v-for="competence in competences" :key="competence.id" class="answer-block">
        <div class="row-block designation">
          <div class="col-xs-6 subtitle-container">
            <div class="subtitle">{{ competence.name }}</div>
          </div>
          <div class="designation__stars">
            <div class="answer-rating">
              <span
                v-for="(_, i) in [...new Array(competence.level.max_value)]"
                :key="i"
                class="answer-rating__inner answer-rating__inner_selectable"
              >
                <i
                  class="fa"
                  :style="{ color: getValueColor(competence.value, competence.level.max_value) }"
                  :class="ratingItemView(competence.value > i)"
                ></i>
              </span>
            </div>

            <div
              v-if="competence.hint"
              v-tooltip.left-start="getHintSettings(competence)"
              class="info-block"
            >
              <img src="/static/icons/info.svg" alt="Help" />
            </div>
          </div>
        </div>
      </div>

      <div class="block-overall-rating">
        <div>
          <div class="text-overall-rating">{{ $tr('responses.tabs.competences.rating') }}</div>
        </div>
        <div>
          <div class="answer-rating">
            <span v-for="(_, i) in [...new Array(maxLevel)]" :key="i" class="answer-rating__inner">
              <i
                class="fa"
                :style="{ color: getValueColor(overallRating, maxLevel) }"
                :class="ratingItemView(overallRating > i)"
              ></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-competences">
      <div class="message">{{ $tr('responses.tabs.competences.noCompetences') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabCompetences',

  props: {
    competences: {
      type: Array,
      required: true
    },

    overallRating: {
      type: Number,
      default: 0
    }
  },

  computed: {
    maxLevel() {
      return this.competences[0] ? this.competences[0].level.max_value : 5;
    },

    ratingViewType() {
      return this.competences[0].view.name || '';
    }
  },

  methods: {
    getValueColor(value, maxColor) {
      if (Math.ceil(value) === 1) return '#ff3232';
      if (Math.ceil(value) === maxColor) return '#00d26e';
      return '#fec500';
    },

    ratingItemView(isMore) {
      if (this.ratingViewType !== 'Circle') {
        if (isMore) {
          return 'fa-star rating__item rating__item_selected';
        } else {
          return 'fa-star-o rating__item rating__item_non-selected';
        }
      } else {
        if (isMore) {
          return 'fa-circle rating__item rating__item_selected';
        } else {
          return 'fa-circle-thin rating__item rating__item_non-selected';
        }
      }
    },

    getHintSettings(competence) {
      const breakSigns = /(\r\n|\n|\r)/gm;

      return {
        content: competence.hint.replace(breakSigns, '<br>'),
        classes: ['competence-helper']
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.tab-competences {
  margin-left: 15px;

  .forbidden {
    margin-top: 20px;
    margin-right: 15px;
  }
}

.answer-block .title {
  margin-left: 16px;
  margin-top: 20px;
  margin-bottom: 33px;
  color: $green;
  font-size: 18px;
}

.answer-block .designation {
  margin-bottom: 20px;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__stars {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    .info-block {
      margin-left: 10px;
      margin-top: 4px;
    }
  }
}

.subtitle-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.answer-block .designation .subtitle {
  font-size: 16px;
  color: #333330;
  margin-left: 0;
}

.answer-rating {
  padding-left: 15px;
  height: 34px;
  line-height: 34px;
  display: flex;
}

.answer-rating__inner {
  margin-right: 10px;
}

.rating__item {
  transition: all 0.7s;
}

.rating__item_non-selected {
  opacity: 0.6;
}

.rating__item_selected {
  opacity: 1;
}

.answer-rating__inner:last-child {
  margin-right: 0;
}

.answer-rating span {
  font-size: 20px;
}

.answer-rating span:first-child:nth-last-child(1) {
  color: #ff3232;
}

.answer-rating span:first-child:nth-last-child(2),
.answer-rating span:first-child:nth-last-child(2) ~ span,
.answer-rating span:first-child:nth-last-child(3),
.answer-rating span:first-child:nth-last-child(3) ~ span {
  color: #fec500;
}

.answer-rating span:first-child:nth-last-child(4),
.answer-rating span:first-child:nth-last-child(4) ~ span,
.answer-rating span:first-child:nth-last-child(5),
.answer-rating span:first-child:nth-last-child(5) ~ span {
  color: $green;
}

.answer-rating span.inactive {
  color: #999999 !important;
}

.block-overall-rating {
  border-top: 1px solid #d7d7d7;
  padding-top: 20px;
  margin-top: 26px;
  margin-bottom: 55px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .answer-rating {
    margin-right: 28px;
  }
}

.text-overall-rating {
  font-size: 24px;
}

.no-competences {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 580px;
  align-items: center;
  width: 100%;
}

.no-competences .message {
  color: $green;
  margin-bottom: 80px;
}

.fa-star-o {
  color: #999999 !important;
}
</style>
